import { Box, TextField, Autocomplete } from '@mui/material';
import theme from '../../theme';
import { Search, Close } from '@mui/icons-material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';
import { trackSearch } from '../../lib/gaEvents';

const HeaderSearchBar = ({ pageType }) => {
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();
  const user = useUserStore((state) => state.user);

  const handleSearch = (e) => {
    e.preventDefault();
    const trimmed = searchValue.trim();
    if (trimmed) {
      trackSearch({ searchTerm: trimmed, pageType }, user);
      navigate(`/search/summary?q=${encodeURIComponent(trimmed)}`);
      setSearchValue('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        px: 1.5,
        backgroundColor: theme.palette.surface.main,
        border: `1px solid ${theme.palette.grey.line}`,
        borderRadius: 1,
      }}
    >
      <Search sx={{ width: 24, height: 24, color: theme.palette.black[1], flexShrink: 0 }} />
      <Autocomplete
        freeSolo
        options={[]}
        sx={{ flex: 1 }}
        inputValue={searchValue}
        onInputChange={(_, newInputValue) => {
          setSearchValue(newInputValue);
        }}
        onSubmit={handleSearch}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="앨범, 아티스트 등 검색"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              sx: {
                fontSize: '14px',
                color: theme.palette.black[8],
              },
              onKeyPress: handleKeyPress,
            }}
          />
        )}
        clearIcon={
          <Close
            sx={{
              width: 14,
              height: 14,
              padding: '2px',
              backgroundColor: theme.palette.black[1],
              borderRadius: '50px',
              color: theme.palette.common.white,
            }}
          />
        }
      />
    </Box>
  );
};

export default HeaderSearchBar;
